import { useMemo } from "react";

import { useCurrentUserRolePermission } from "@vega-api/extended/auth/permissions/useCurrentUserRolePermission";

export const useMyAccessData = () => {
  const { isLoading, isFetched, currentUserPermissions } =
    useCurrentUserRolePermission();

  const userPermissions = useMemo(
    () =>
      currentUserPermissions.map((permission) => ({
        ...permission,
        manageable: false,
        userId: "",
        permissionEnabled: permission.permissionEnabled,
        permissionId: permission.permissionId,
        featureName: permission.permissionId,
      })),
    [currentUserPermissions],
  );

  return { isLoading, isFetched, currentUserPermissions, userPermissions };
};
